import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MarketingLayout from "./components/MarketingLayout.js";
import MarketingFooterCtas from "./components/MarketingFooterCtas.js";

export default function Teams() {
  const { t } = useTranslation();

  const features = [
    { kicker: "Space", title: t("teams_workspace"), text: t("teams_workspace_desc") },
    { kicker: "Admin", title: t("teams_management"), text: t("teams_management_desc") },
    { kicker: "Share", title: t("teams_shared"), text: t("teams_shared_desc") },
    { kicker: "Insight", title: t("teams_analytics"), text: t("teams_analytics_desc") },
  ];

  return (
    <MarketingLayout>
      <div className="marketing-page-content teams-page teams-page--wide">
        <header className="marketing-page-intro">
          <p className="marketing-page-eyebrow">Solutions</p>
          <h1>{t("teams_title")}</h1>
          <p className="page-lead">{t("teams_subtitle")}</p>
        </header>

        <div className="teams-grid">
          {features.map((item) => (
            <section key={item.title} className="marketing-section-card">
              <span className="marketing-kicker" aria-hidden>
                {item.kicker}
              </span>
              <h2 className="marketing-section-title">{item.title}</h2>
              <p className="marketing-section-text">{item.text}</p>
            </section>
          ))}
        </div>

        <div className="marketing-section-card teams-cta-block">
          <h2 className="marketing-section-title">{t("ready_to_start")}</h2>
          <p className="marketing-section-text mb-4">{t("join_teams")}</p>
          <div className="marketing-cta-row" style={{ marginTop: 0 }}>
            <Link to="/pricing" className="marketing-cta">
              {t("view_team_pricing")}
            </Link>
            <Link to="/Contact" className="marketing-cta marketing-cta--secondary">
              {t("contact_sales")}
            </Link>
          </div>
        </div>

        <MarketingFooterCtas />
      </div>
    </MarketingLayout>
  );
}
